module.exports = __webpack_public_path__ + "static/media/11、山西省忻州市经济开发区“新型半导体材料产业化”工业园项目可研编制咨询-min.3c2ad810.jpg";